@if (product$ | async; as product) {
  @if (product.numberOfReviews > 0) {
    <div class="container">
      <h2>
        {{ 'productDetails.reviews' | cxTranslate }}
        <span>{{ 'productDetails.comments' | cxTranslate : {number: product.numberOfReviews} }}</span></h2>
        @if (!isWritingReview) {
          <div class="header">
            <button
              #writeReviewButton
              class="btn btn-white"
              (click)="initiateWriteReview()"
              >
              {{ 'productReview.writeReview' | cxTranslate }}
            </button>
            @if (product.averageRating) {
              <cx-star-rating
                class="rating"
                [rating]="product.averageRating"
              ></cx-star-rating>
            }
            @if (!product.averageRating) {
              <div class="rating">
                {{ 'productDetails.noReviews' | cxTranslate }}
              </div>
            }
          </div>
          @if (!isWritingReview) {
            @if (reviews$ | async; as reviews) {
              @for (review of reviews | slice: 0:maxListItems; track review) {
                <div
                  class="review"
                  tabindex="0"
                  >
                  <div class="title">{{ review.headline }}</div>
                  @if (review.rating) {
                    <cx-star-rating [rating]="review.rating"></cx-star-rating>
                  }
                  <div class="name">
                    {{ review.alias ? review.alias : review.principal?.name }}
                  </div>
                  <div class="date">{{ review.date | cxDate }}</div>
                  <div class="text">{{ review.comment }}</div>
                </div>
              }
              @if (reviews.length > initialMaxListItems) {
                <div class="wrapper-buttons">
                  @if (maxListItems === initialMaxListItems) {
                    <button
                      class="btn btn-green"
                      (click)="maxListItems = reviews.length"
                      >
                      {{ 'productReview.more' | cxTranslate }}
                    </button>
                  }
                  @if (maxListItems !== initialMaxListItems) {
                    <button
                      class="btn btn-green"
                      (click)="maxListItems = initialMaxListItems"
                      >
                      {{ 'productReview.less' | cxTranslate }}
                    </button>
                  }
                </div>
              }
            }
          } @else {
            <form (ngSubmit)="submitReview(product)" [formGroup]="reviewForm">
              <div class="form-group">
                <label>
                  <span class="label-content">{{
                    'productReview.reviewTitle' | cxTranslate
                  }}</span>
                  <input
                    #titleInput
                    type="text"
                    class="form-control"
                    formControlName="title"
                    />
                  <cx-form-errors [control]="reviewForm.get('title')"></cx-form-errors>
                </label>
              </div>
              <div class="form-group">
                <label>
                  <span class="label-content">{{
                    'productReview.writeYourComments' | cxTranslate
                  }}</span>
                  <textarea
                    class="form-control"
                    rows="3"
                    formControlName="comment"
                  ></textarea>
                  <cx-form-errors
                    [control]="reviewForm.get('comment')"
                  ></cx-form-errors>
                </label>
              </div>
              <div class="form-group">
                <label>
                  <span class="label-content">{{
                    'productReview.rating' | cxTranslate
                  }}</span>
                  <input type="number" formControlName="rating" class="rating-input"/>
                  <cx-star-rating
                    (change)="setRating($event)"
                    [disabled]="false"
                  ></cx-star-rating>
                  <cx-form-errors [control]="reviewForm.get('rating')"></cx-form-errors>
                </label>
              </div>
              <div class="form-group">
                <label>
                  <span class="label-content">{{
                    'productReview.reviewerName' | cxTranslate
                  }}</span>
                  <input
                    type="text"
                    class="form-control"
                    formControlName="reviewerName"
                    />
                </label>
              </div>
              <div class="form-group row">
                <div class="col-12 col-md-4">
                  <button
                    type="button"
                    class="btn btn-block btn-white"
                    (click)="cancelWriteReview()"
                    >
                    {{ 'common.cancel' | cxTranslate }}
                  </button>
                </div>
                <div class="col-12 col-md-4">
                  <button type="submit" class="btn btn-block btn-green">
                    {{ 'common.submit' | cxTranslate }}
                  </button>
                </div>
              </div>
            </form>
          }
        } @else {
          <form (ngSubmit)="submitReview(product)" [formGroup]="reviewForm">
            <div class="form-group">
              <label>
                <span class="label-content">{{
                  'productReview.reviewTitle' | cxTranslate
                }}</span>
                <input
                  #titleInput
                  type="text"
                  class="form-control"
                  formControlName="title"
                  />
                <cx-form-errors [control]="reviewForm.get('title')"></cx-form-errors>
              </label>
            </div>
            <div class="form-group">
              <label>
                <span class="label-content">{{
                  'productReview.writeYourComments' | cxTranslate
                }}</span>
                <textarea
                  class="form-control"
                  rows="3"
                  formControlName="comment"
                ></textarea>
                <cx-form-errors
                  [control]="reviewForm.get('comment')"
                ></cx-form-errors>
              </label>
            </div>
            <div class="form-group">
              <label>
                <span class="label-content">{{
                  'productReview.rating' | cxTranslate
                }}</span>
                <input type="number" formControlName="rating" class="rating-input"/>
                <cx-star-rating
                  (change)="setRating($event)"
                  [disabled]="false"
                ></cx-star-rating>
                <cx-form-errors [control]="reviewForm.get('rating')"></cx-form-errors>
              </label>
            </div>
            <div class="form-group">
              <label>
                <span class="label-content">{{
                  'productReview.reviewerName' | cxTranslate
                }}</span>
                <input
                  type="text"
                  class="form-control"
                  formControlName="reviewerName"
                  />
              </label>
            </div>
            <div class="form-group row">
              <div class="col-12 col-md-4">
                <button
                  type="button"
                  class="btn btn-block btn-white"
                  (click)="cancelWriteReview()"
                  >
                  {{ 'common.cancel' | cxTranslate }}
                </button>
              </div>
              <div class="col-12 col-md-4">
                <button type="submit" class="btn btn-block btn-green">
                  {{ 'common.submit' | cxTranslate }}
                </button>
              </div>
            </div>
          </form>
        }
      </div>
    }
  }
